// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1D_08","chart":"chart__1kuX6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BarChart/styles.scss
// module id = 2120
// module chunks = 1